import React from 'react'
import LoadingBox from '../LoadingBox'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

const PageSkeleton = () => {
  return (
    <Box mt={20}>
      <Container maxWidth="lg">
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <LoadingBox width={0.4} height={40} mb={4} />
            <LoadingBox height={24} mb={4} />
            <LoadingBox height={24} mb={4} />
            <LoadingBox height={24} mb={4} width={0.75} />
          </Grid>
          <Grid item xs={4}>
            <LoadingBox width={0.4} height={32} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} width={0.75} />
          </Grid>
          <Grid item xs={4}>
            <LoadingBox width={0.4} height={32} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} width={0.75} />
          </Grid>
          <Grid item xs={4}>
            <LoadingBox width={0.4} height={32} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} />
            <LoadingBox height={16} mb={4} width={0.75} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default PageSkeleton
